var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMenu)?_c('ModalBackground',{on:{"closeMenu":_vm.closeMenu}}):_vm._e(),_vm._v(" "),_c('Menu',{attrs:{"isMenu":_vm.isMenu},on:{"closeMenu":_vm.closeMenu}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfc70ca4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LP/organisms/SlideMenu.vue
// module id = null
// module chunks = 